import styled from "styled-components";

export const Form = styled.form`
    margin: 0;
    padding: 0;
    position: relative;
    max-width: 200px;
`;

export const Input = styled.input`
    border: none;
    border-bottom: 1px solid black;
    background: none;
    font-size: 1.6rem;
    padding: 0.5rem 4rem 0.5rem 1rem;
    display: block;
    width: 100%;
`;

export const Button = styled.button`
    border: none;
    background: none;
    cursor: pointer;
    position: absolute;
    padding: 0.5rem;
    top: 0.1rem;
    right: 0;

    
`;